import { Button } from '@wegroup/design-system';
import React from 'react';
interface Props {
  isActive?: boolean;
  onClick?: () => void;
}

const ActiveButton: React.FC<React.PropsWithChildren<Props>> = ({
  isActive,
  onClick,
  children,
}) => {
  return (
    <Button
      h="auto"
      py="1.5"
      whiteSpace="unset"
      variant={isActive ? 'primary' : 'secondary'}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default ActiveButton;
